import styles from "./DiagonalDivider.module.css";

export default function TextBlock({ title, paragraphs, Icon }) {
  return (
    <div className={styles.textBlock}>
      <div className={styles.textBlockHeader}>
        <img src={Icon} alt="" />
        <h3>{title}</h3>
      </div>
      <div className={styles.textBlockContent}>
        {paragraphs.map((text, index) => (
          <p key={index}>{text}</p>
        ))}
      </div>
    </div>
  );
}
